import { LoanApplicationService } from '../../loan-application.service';
import { ApplicationSourceSelectService } from 'src/app/@modules/application-source-select/application-source-select.service';
var ReferenceComponent = /** @class */ (function () {
    function ReferenceComponent(loan, source) {
        this.loan = loan;
        this.source = source;
    }
    Object.defineProperty(ReferenceComponent.prototype, "invalid", {
        get: function () {
            return this.loan.form.get('application_source').dirty && this.loan.form.get('application_source').hasError('required');
        },
        enumerable: true,
        configurable: true
    });
    return ReferenceComponent;
}());
export { ReferenceComponent };
